module.exports = __webpack_public_path__ + "img/hoghugh.7c6372a7.jpg";